import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {setHours, setMinutes} from "date-fns";
import classnames from "classnames";
import {InputGroupAddon} from "reactstrap";
import InputGroup from "reactstrap/es/InputGroup";

class InputDatetime extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      valid: false,
      isError: false
    }

    this.getMaxTime = this.getMaxTime.bind(this);
    this.getMinTime = this.getMinTime.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.isValid = this.isValid.bind(this)
  }

  getMinTime(){
    if(!this.props.question.dateTimeMinTime){
      return null;
    }

    const splitted = this.props.question.dateTimeMinTime.split(':')

    return moment().hours(splitted[0]).minutes(splitted[1])
  }

  getMaxTime(){
    if(!this.props.question.dateTimeMaxTime){
      return null;
    }

    const splitted = this.props.question.dateTimeMaxTime.split(':')

    return moment().hours(splitted[0]).minutes(splitted[1])
  }

  updateValue(value){
    this.setState({
      value,
    }, () => {
      this.props.onChange(this.state.value)
    });
  }

  isValid(max, min, value) {
    const { validate } = this.props;
    const time = moment(value);

    if ((!_.isNull(validate) && validate.errors.length > 0) && !value) {
      return false;
    }

    if (!value) {
      return false;
    }

    let result = false;

    if (max) {
      max = moment(max);
      if (max.isSameOrAfter(time)) {
        result = true;
      } else {
        result = false;
      }
    }

    if (min) {
      min = moment(min);
      if (min.isSameOrBefore(time)) {
        result = true;
      } else {
        result = false;
      }
    }

    return result;
  }

  render() {
    const { question, validate } = this.props;

    const minTime = question.dateTimeMinDate
    const maxTime = question.dateTimeMaxDate

    const valid = this.isValid(maxTime, minTime, this.state.value);

    return (
        <InputGroup className={
          classnames({
            'valid': this.state.value,
            'error': (!_.isNull(validate) && validate.errors.length > 0) && !this.state.value,
            'icon-input': true
          })
        }>
          <InputGroupAddon addonType={"prepend"} className={
            classnames({
              'valid': this.state.value,
              'error': (!_.isNull(validate) && validate.errors.length > 0) && !this.state.value
            })
          }>
            <i className="fas fa-calendar-alt" />
          </InputGroupAddon>
          <div className={classnames({
            "datepicker": true
          })}>
            <DatePicker
                popperPlacement="bottom"
                popperModifiers={{
                  flip: {
                    behavior: ["bottom"] // don't allow it to flip to be above
                  },
                  preventOverflow: {
                    enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                  },
                  hide: {
                    enabled: false // turn off since needs preventOverflow to be enabled
                  }
                }}
                dropdownMode={'select'}
                isClearable={true}
                minDate={question.dateTimeMinDate && moment(question.dateTimeMinDate)}
                maxDate={question.dateTimeMaxDate && moment(question.dateTimeMaxDate)}
                placeholderText={"Wybierz date"}
                selected={this.state.value ? moment(this.state.value) : null}
                onChange={(date) => {
                  this.updateValue(date ? date.format(question.dateTimeSelect ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD') : null)
                }}
                showTimeSelect={question.dateTimeSelect}
                timeFormat="HH:mm"
                minTime={this.getMinTime()}
                maxTime={this.getMaxTime()}
                // timeIntervals={question.dateTimeIntervals}
                timeIntervals={30}
                dateFormat={question.dateTimeSelect ? 'Y-MM-DD HH:mm' : 'Y-MM-DD'}
                locale={localStorage.surveyLanguage}
            />
          </div>
        </InputGroup>
    );
  }
}

InputDatetime.propTypes = {
  onChange: PropTypes.func.isRequired,
  question: PropTypes.shape({
    dateTimeMinDate: PropTypes.string,
    dateTimeMaxDate: PropTypes.string,
    dateTimeMinTime: PropTypes.string,
    dateTimeMaxTime: PropTypes.string,
    dateTimeSelect: PropTypes.bool.isRequired,
    dateTimeIntervals: PropTypes.number.isRequired,
  }).isRequired,
};

export default InputDatetime;
